module.exports = __webpack_public_path__ + "img/hkstp-20230831.91efd39e.jpg";